export default {
  order_methods: {
    delivery: 'Dostawa',
    pickup: 'Odbiór',
    room_service: 'Na miejscu',
    table_service: 'Na miejscu',
  },
  time: '{{time}} min',
  asap: 'ASAP',
  unavailable: 'Niedostępne',
  ready_in: 'Gotowe za ',
  buttons: {
    change: 'Zmień',
    see_hours: 'Zobacz godziny',
    change_location: 'Zmień lokalizację',
    change_time: 'Zmień godzinę',
  },
};
